import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth'
import { isSuperAdmin } from '@/lib/role'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { superAdminAPI } from '@/api/superAdmin'
import { Button } from '@/components/ui/button'

export function TenantViewBar() {
  const user = useAuthStore((s) => s.user)
  const activeTenantId = useAuthStore((s) => s.activeTenantId)
  const setActiveTenantId = useAuthStore((s) => s.setActiveTenantId)
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const { data: tenants = [] } = useQuery({
    queryKey: ['tenants'],
    queryFn: superAdminAPI.listTenants,
    enabled: isSuperAdmin(user?.role) && !!activeTenantId,
  })

  if (user?.role !== 'super_admin' || !activeTenantId) return null

  const currentTenant = tenants.find((t) => t.id === activeTenantId)

  const switchBack = () => {
    setActiveTenantId(null)
    queryClient.clear()
    navigate('/organizations', { replace: true })
  }

  return (
    <div className="flex items-center justify-between px-4 py-2 bg-amber-50 border-b border-amber-200 text-sm">
      <span className="text-amber-800">
        Currently viewing as: <strong>{currentTenant?.name ?? 'Loading...'}</strong>
      </span>
      <Button variant="outline" size="sm" onClick={switchBack}>
        Switch back to Super Admin view
      </Button>
    </div>
  )
}
